<template>
    <div class="o-page__content u-pt-small">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-xl-12">
                    <h1 class="u-h3">Report <span v-if="role_id==2">: Wilayah {{relation_name}}</span><span v-if="role_id==3">: Outlet {{relation_name}}</span></h1>
                    <div style="display: inline-block; float: right; margin-top: -40px;">
                        <el-date-picker
                            v-model="daterange"
                            type="daterange"
                            format="dd MMM yyyy"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Start"
                            @change="dateChanged"
                            :picker-options="datePickerOptions"
                            end-placeholder="End">
                        </el-date-picker>
                    </div>
                    <div class="custom_toolbar u-mt-medium">
                        <Select2 v-if="role_id==1||4" class="c-input" v-model="params.region" :options="regions" :settings="{ width: '100%', placeholder: 'All Region' }" @change="myChangeEvent($event)"/>
                        <Select2 v-if="role_id!=3" class="c-input" v-model="params.branch" :options="branches" :settings="{ width: '100%', placeholder: 'All Branch' }" @change="myChangeEvent2($event)"/>
                        <Select2 v-if="role_id!=3" class="c-input" v-model="params.outlet" :options="outlets" :settings="{ width: '100%', placeholder: 'All Outlet' }" @change="myChangeEvent3($event)"/>
                        <Select2 class="c-input" v-model="params.position" :options="positions" :settings="{ width: '100%', placeholder: 'All Type' }" @change="myChangeEvent4($event)"/>
                        <el-button size="mini" icon="el-icon-download" @click="excel">Export</el-button>
                        <el-button size="mini" icon="el-icon-refresh-left" @click="reset">Reset</el-button>
                        <input type="text" placeholder="Search..." class="c-input" v-model="params.q" v-on:keyup="search">
                    </div>
                </div>
            </div>
            <div class="row u-mt-medium">
                <div class="col-12">
                    <vue-good-table v-loading="loading"
                        mode="remote"
                        :columns="columns"
                        :rows="rows"
                        :totalRows="totalRecords"
                        @on-page-change="onPageChange"
                        :select-options="{ 
                            enabled: true,
                            selectOnCheckboxOnly: true,
                            disableSelectInfo: true
                        }"
                        :pagination-options="{
                            enabled: true
                        }">
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'outlet'">
                                <el-row type="flex" justify="center">
                                    <el-col>
                                        <div v-show="props.row.is_facility == 0">
                                            <el-tag type="info" size="mini">{{JSON.parse(props.row.object).id}}</el-tag>&nbsp;
                                            <el-tag type="info" v-show="JSON.parse(props.row.object).position_name" size="mini">{{JSON.parse(props.row.object).position_name}}</el-tag>
                                            <el-tag type="info" v-show="JSON.parse(props.row.object).category_name" size="mini">{{JSON.parse(props.row.object).category_name}}</el-tag>
                                        </div>
                                        {{JSON.parse(props.row.object).name}}<br/>
                                        <el-tag size="mini">{{props.row.region_name}}</el-tag><br/>
                                        <el-tag size="mini">{{props.row.branch_name}}</el-tag><br/>
                                        <el-tag size="mini">{{props.row.outlet_name}}</el-tag>
                                    </el-col>
                                </el-row>
                            </span>
                            <span v-else-if="props.column.field == 'rating'">
                                <!-- <el-tag size="mini"> -->
                                    <el-button class="u-mb-xsmall" type="primary" size="mini">
                                    Rata-rata: {{parseFloat(Math.round((props.row.average/5)*100))}}
                                    <el-rate
                                        :value="parseFloat(props.row.average)"
                                        disabled
                                        text-color="#ff9900"
                                        score-template="{value}">
                                    </el-rate>
                                    </el-button>
                                <!-- </el-tag> -->
                                <span v-for="(item, id) in JSON.parse(props.row.rating)" :key="id">
                                    <!-- <el-tag type="info" size="mini"> -->
                                        <el-button class="u-mb-xsmall" size="mini">
                                        {{ item.name }}:
                                        <span style="color: rgb(255, 153, 0);">{{(item.star/5)*100}}</span>
                                        <el-rate
                                            :value="parseFloat(item.star)"
                                            disabled
                                            text-color="#ff9900"
                                            score-template="{value}">
                                        </el-rate>
                                        </el-button>
                                    <!-- </el-tag> -->
                                </span>
                            </span>
                            <span v-else-if="props.column.field == 'attachment'">
                                <span v-if="props.row.attachment.includes('attachment')">
                                    <el-image
                                        style="width: 80px; height: 80px;"
                                        :src="props.row.attachment"
                                        :preview-src-list="[props.row.attachment]">
                                    </el-image>
                                </span>
                                <span v-else :span="12">
                                    <span>-</span>
                                </span>
                            </span>
                            <span v-else-if="props.column.field == 'id'">
                                <el-button @click="downloadDetail(props.row.id, props.row.object, props.row.outlet_code, props.row.outlet_name, dateField2(props.row.created_at))" size="mini" icon="el-icon-download">
                                </el-button>
                                <el-button v-if="role_id==4" @click="showAlertDelete(props.row.id)" size="mini" icon="el-icon-delete">
                                </el-button>
                            </span>
                            <span v-else>
                                {{props.formattedRow[props.column.field]}}
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table';
    import api from '@/api/ratings'
    import regions from '@/api/regions'
    import branches from '@/api/branches'
    import outlets from '@/api/outlets'
    import Select2 from 'v-select2-component';
    import { mapActions } from 'vuex';
    import moment from 'moment'

    export default {
        components: {
            'vue-good-table':VueGoodTable,
            Select2
        },
        data() {
            return {
                role_id: localStorage.getItem('user_role_id'),
                relation_code: localStorage.getItem('relation_code'),
                relation_name: localStorage.getItem('relation_name'),
                columns: [
                    {
                        label: 'Waktu Kunjungan',
                        field: this.dateField
                    },
                    {
                        label: 'Petugas Penilai',
                        field: 'author_name'
                    },
                    {
                        label: 'Data Penilaian',
                        field: 'outlet'
                    },
                    {
                        label: 'Penilaian',
                        field: 'rating',
                        thClass: 'u-text-center',
                        tdClass: 'u-text-center',
                        width: '200px'
                    },
                    {
                        label: 'Foto',
                        field: 'attachment',
                        thClass: 'u-text-center',
                        tdClass: 'u-text-center',
                    },
                    {
                        label: 'Komentar',
                        field: 'note'
                    },
                    {
                        label: 'Aksi',
                        field: 'id',
                        thClass: 'u-text-center',
                        tdClass: 'u-text-center',
                        width: '150px'
                    }
                ],
                chartEvents: {
                    'select': () => {
                        // const table = this.$refs.gChart.chartObject;
                        // const selection = table.getSelection();
                        // var row = selection[0].row;
                        // this.params.region = this.regions[selection[0].row].id
                        // this.fetchBranches()
                        // this.fetch()
                    }
                },
                daterange: [],
                datePickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },
                rows: [],
                totalRecords: 0,
                page: 1,
                regions: [],
                branches: [],
                outlets: [],
                positions: [
                    {
                        id: '',
                        text: 'All Type'
                    },
                    {
                        id: 2,
                        text: 'Employees'
                    },{
                        id: 1,
                        text: 'Premises'
                    }
                ],
                params: {
                    q: '',
                    position: '',
                    region: localStorage.getItem('user_role_id') == 2 ? localStorage.getItem('relation_code') : '',
                    outlet: localStorage.getItem('user_role_id') == 3 ? localStorage.getItem('relation_code') : '',
                    branch: ''
                },
                loading: false,
                errorMessage: null
            }
        },
        created () {
            let end = new Date()
            var start = moment(start).subtract(1, 'months')._d;
            this.daterange = [start, end]
            this.fetch();
            if(this.role_id==1||4){
                this.fetchRegions();
            }
            if(this.role_id==2){
                this.fetchBranches();
            }
        },
        methods: {
            ...mapActions([
                'logout'
            ]),
            dateField(rowObj) {
                return moment(rowObj.created_at).format('dddd, DD MMMM YYYY / H:mm')
            },
            dateField2(rowObj) {
                return moment(rowObj).format('DD-MM-YYYY/H:mm')
            },
            excel() {
                this.loading = true
                var self = this
                api.excel(this.params.region, this.params.branch, this.params.outlet, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'), this.params.position, this.params.q)
                .then(function (response) {
                    self.loading = false
                    let blob = new Blob([response.data], { type: response.data.type })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    let region = []
                    self.regions.forEach(element => {
                        if(element.id === self.params.region){
                            region.push({name:` Region[${element.text}]`})
                        }
                    });
                    let branch = []
                    self.branches.forEach(element => {
                        if(element.id === self.params.branch){
                            branch.push({name:` Branch[${element.text}]`})
                        }
                    });
                    let outlet = []
                    self.outlets.forEach(element => {
                        if(element.id === self.params.outlet){
                            outlet.push({name:` Outlet[${element.text}]`})
                        }
                    });
                    link.download = `Report from ${moment(self.daterange[0]).format('YYYY-MM-DD')} to ${moment(self.daterange[1]).format('YYYY-MM-DD')}${region.length>0?region[0]['name']:''}${branch.length>0?branch[0]['name']:''}${outlet.length>0?outlet[0]['name']:''}${self.params.position?(self.params.position==='1'?' Premises':' Employees'):''}.xlsx`
                    link.click()
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            downloadDetail(id, object, outlet_code, outlet_name, date) {
                this.loading = true
                let self = this
                let nip = JSON.parse(object).id
                let name = JSON.parse(object).name
                let position = JSON.parse(object).position_name ? JSON.parse(object).position_name : JSON.parse(object).category_name
                api.detail(id)
                .then(function (response) {
                    self.loading = false
                    let blob = new Blob([response.data], { type: response.data.type })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    if(JSON.parse(object).name !== 'PREMISE') {
                        link.download = `Report[${nip}-${name}-${position}]-${date}.pdf`
                    } else {
                        link.download = `Report[${outlet_code}-${outlet_name}]-${date}.pdf`
                    }
                    link.click()
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            showAlertDelete(id){
                this.$confirm('This will permanently delete the rating. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.deleteRow(id)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            deleteRow(id) {
                this.loading = true
                let self = this
                api.delete(id)
                .then(function (response) {
                    self.loading = false
                    self.$message({
                        type: 'success',
                        message: 'Delete completed'
                    });
                    self.fetch()
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetch() {
                this.loading = true
                var self = this
                api.get(this.page, this.params.region, this.params.branch, this.params.outlet, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'), this.params.position, this.params.q)
                .then(function (response) {
                    self.rows = response.data.data
                    self.totalRecords = response.data.meta.totalRecords
                    self.loading = false
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            onPageChange(params) {
                console.log(params)
                this.page = params.currentPage
                this.fetch();
            },
            fetchRegions() {
                this.loading = true
                var self = this
                regions.getAll()
                .then(function (response) {
                    // 
                    var regionsx = [];
                    response.data.data.forEach(element => {
                        regionsx.push({
                            id: element.code,
                            text: element.name
                        });
                    });
                    self.regions = regionsx
                    self.loading = false
                    // console.log(self.regions)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchBranches() {
                var self = this
                branches.getAll(this.params.region)
                .then(function (response) {
                    // 
                    var regionsx = [];
                    response.data.data.forEach(element => {
                        regionsx.push({
                            id: element.code,
                            text: element.name
                        });
                    });
                    self.branches = regionsx
                    // console.log(self.branches)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchOutlets() {
                var self = this
                outlets.getAll(this.params.region, this.params.branch)
                .then(function (response) {
                    // 
                    var regionsx = [];
                    response.data.data.forEach(element => {
                        regionsx.push({
                            id: element.code,
                            text: element.name
                        });
                    });
                    self.outlets = regionsx
                    // console.log(self.outlets)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            myChangeEvent(val){
                console.log(val);
                this.params.region = val
                this.params.branch = ''
                this.fetchBranches()
                this.fetch();
            },
            myChangeEvent2(val){
                console.log(val);
                this.params.branch = val
                this.params.outlet = ''
                this.fetchOutlets();
                this.fetch();
            },
            myChangeEvent3(val){
                console.log(val);
                this.params.outlet = val
                this.fetch();
            },
            myChangeEvent4(val){
                console.log(val);
                this.params.position = val
                this.fetch();
            },
            search() {
                this.fetch();
            },
            dateChanged() {
                // console.log(this.daterange)
                this.fetch()
            },
            reset() {
                this.branches = []
                this.params = {
                    region: '',
                    branch: '',
                    outlet: '',
                    position: '',
                    q: ''
                }
                let end = new Date()
                var start = moment(start).subtract(1, 'months')._d;
                this.daterange = [start, end]
                this.fetch()
            }
        },
    }
</script>

<style lang="scss" scoped>
.custom_toolbar {
    display: flex;
    div, button {
        margin-right: 10px;
    }
}
.el-row--flex.is-justify-center {
    align-items: center !important;
}
</style>